module.exports = __webpack_public_path__ + "img/iconNo4.3e1d4be0.png";